/**
 * 处理从后台获取到的im消息
 * @param { array } chatHis 从后台获取到的im聊天列表
 * @param { string } visitID im聊天群组id（没有GROUP)列表
 * @param { string } doctorImId im聊天医生imId, 医生聊天内容在右侧
 * @param { string } doctorIcon im聊天医生头像 医生聊天内容在右侧
 * @param { string } patientIcon im聊天病人头像 受者聊天内容在左侧
 * @return { array } []
 * **/

export const formatImMessage = (
  chatHis = [],
  visitID = '',
  doctorImId = '',
  doctorIcon = '',
  patientIcon = ''
) => {
  return chatHis.reduce((result, item, index) => {
    // 设置聊天内容
    let nItem = {
      isStatic: true // 标记消息记录只是观看不可操作
    }
    if (item.MsgBody.length === 0) {
      return result
    }
    const payloadHash = {
      TIMSoundElem: () =>
        item.MsgBody.map(({ MsgContent: contentItem }) => {
          // 音频
          return {
            downloadFlag: contentItem.Download_Flag,
            remoteAudioUrl: contentItem.Url,
            second: contentItem.Second,
            size: contentItem.Size,
            url: contentItem.Url,
            uuid: contentItem.UUID
          }
        })[0],
      TIMImageElem: () =>
        item.MsgBody.map(({ MsgContent: contentItem, UUID }) => {
          // 图片
          return {
            imageFormat: contentItem.ImageFormat,
            imageInfoArray: contentItem.ImageInfoArray.map(image => {
              return {
                height: image.Height,
                imageUrl: image.URL,
                size: image.Size,
                sizeType: image.Type,
                type: image.Type, // 0-原图 1-198p压缩图 2-720p压缩图
                url: image.URL,
                width: image.Width
              }
            }),
            uuid: UUID
          }
        })[0],
      TIMVideoFileElem: () =>
        item.MsgBody.map(({ MsgContent: contentItem }) => {
          // 视频文件
          return {
            remoteVideoUrl: contentItem.VideoUrl,
            thumbDownloadFlag: contentItem.ThumbDownloadFlag,
            thumbFormat: contentItem.ThumbFormat,
            thumbHeight: contentItem.ThumbHeight,
            thumbSize: contentItem.ThumbSize,
            thumbUUID: contentItem.ThumbUUID,
            thumbUrl: contentItem.ThumbUrl,
            thumbWidth: contentItem.ThumbWidth,
            videoDownloadFlag: contentItem.VideoDownloadFlag,
            videoFormat: contentItem.VideoFormat,
            videoSecond: contentItem.VideoSecond,
            videoSize: contentItem.VideoSize,
            videoUUID: contentItem.VideoUUID,
            videoUrl: contentItem.VideoUrl
          }
        })[0],
      TIMTextElem: () =>
        item.MsgBody.map(({ MsgContent: contentItem }) => {
          // 文本
          return {
            text: contentItem.Text
          }
        })[0],
      TIMFaceElem: () =>
        item.MsgBody.map(({ MsgContent: contentItem }) => {
          // 表情
          return {
            text: contentItem.Data
          }
        })[0],
      TIMLocationElem: () =>
        item.MsgBody.map(({ MsgContent: contentItem }) => {
          // geo
          return {
            description: '',
            latitude: 0,
            longitude: 0
          }
        })[0],
      TIMCustomElem: () =>
        item.MsgBody.map(({ MsgContent: contentItem }) => {
          // 自定义消息
          return {
            data: contentItem.Data,
            description: contentItem.Desc,
            extension: contentItem.Ext
          }
        })[0],
      TIMFileElem: () =>
        item.MsgBody.map(({ MsgContent: contentItem, UUID }) => {
          // 文件
          return {
            uuid: UUID,
            fileName: '',
            fileUrl: '',
            fileSize: 0
          }
        })[0]
    }
    if (item.From_Account === '@TIM#SYSTEM') {
      // 系统消息
      nItem = Object.assign(nItem, {
        ID: index,
        atUserList: [],
        avatar: '',
        clientSequence: item.MsgSeq,
        cloudCustomData: '',
        conversationID: `GROUP${visitID}`,
        conversationSubType: undefined,
        conversationType: 'GROUP',
        flow: 'in',
        from: item.From_Account,
        isDeleted: false,
        isModified: false,
        isPeerRead: false,
        isPlaceMessage: item.IsPlaceMsg,
        isRead: true,
        isResend: false,
        isRevoked: false,
        isSystemMessage: item.From_Account === '@TIM#SYSTEM',
        nameCard: '',
        nick: '',
        payload: {
          // 系统消息
          groupJoinType: item.MsgBody.GroupJoinType,
          groupProfile: {
            from: item.From_Account,
            groupID: visitID,
            groupName: 'group',
            to: ''
          },
          memberCount: item.MsgBody.MemberNum,
          memberNum: item.MsgBody.MemberNum,
          operationType: item.MsgBody.OpType,
          operatorID: item.MsgBody.Operator_Account,
          userIDList: item.MsgBody.List_Account
        }, // 未处理
        priority: 'Lowest',
        protocol: 'JSON',
        random: item.MsgRandom,
        sequence: item.MsgSeq,
        status: 'success',
        time: item.MsgTimeStamp,
        to: item.visitID,
        type: 'TIMGroupTipElem'
      })
    } else if (doctorImId === item.From_Account) {
      // 医生聊天记录, 右侧发消息人
      nItem = Object.assign(nItem, {
        ID: index,
        atUserList: [],
        avatar: doctorIcon || '',
        clientSequence: item.MsgSeq,
        cloudCustomData: '',
        conversationID: `GROUP${visitID}`,
        conversationSubType: undefined,
        conversationType: 'GROUP',
        flow: 'out',
        from: item.From_Account,
        isDeleted: false,
        isModified: false,
        isPeerRead: false,
        isPlaceMessage: item.IsPlaceMsg,
        isRead: true,
        isResend: false,
        isRevoked: false,
        isSystemMessage: item.From_Account === '@TIM#SYSTEM',
        nameCard: '',
        nick: '',
        payload: payloadHash[item.MsgBody[0].MsgType](), // 未处理
        priority: 'Normal',
        protocol: 'JSON',
        random: item.MsgRandom,
        sequence: item.MsgSeq,
        status: 'success',
        time: item.MsgTimeStamp,
        to: item.visitID,
        type: item.MsgBody[0].MsgType
      })
    } else {
      // 病人聊天记录, 左侧收到的消息
      nItem = Object.assign(nItem, {
        ID: index,
        atUserList: [],
        avatar: patientIcon,
        clientSequence: item.MsgSeq,
        cloudCustomData: '',
        conversationID: `GROUP${visitID}`,
        conversationSubType: undefined,
        conversationType: 'GROUP',
        flow: 'in',
        from: item.From_Account,
        isDeleted: false,
        isModified: false,
        isPeerRead: false,
        isPlaceMessage: item.IsPlaceMsg,
        isRead: true,
        isResend: false,
        isRevoked: false,
        isSystemMessage: item.From_Account === '@TIM#SYSTEM',
        // nameCard: patientName,
        nameCard: '',
        // nick: patientName,
        nick: '',
        payload: payloadHash[item.MsgBody[0].MsgType](), // 未处理
        priority: 'Normal',
        protocol: 'JSON',
        random: item.MsgRandom,
        sequence: item.MsgSeq,
        status: 'success',
        time: item.MsgTimeStamp,
        to: item.visitID,
        type: item.MsgBody[0].MsgType
      })
    }
    // 有系统消息 病人聊天 医生聊天 其它
    if (nItem.ID !== null && nItem.ID !== undefined) {
      if (nItem.payload && nItem.payload.description === 'setStatus') {
        return result
      }
      result.unshift(nItem)
    }
    return result
  }, [])
}
// import { mapMutations } from 'vuex'
// import testData from '@views/timpackage/utils/test.js'
// 测试im聊天列表
// ...mapMutations('IM/message', ['setRecordMessageList'])
// const ontest = () => {
//   // 把历史消息格式化成需要的格式，如果是从腾讯im调用sdk获取到的聊天记录不用调用该方法
//   const list = formatImMessage(
//     testData,
//     '1057291004904050688',
//     '27216_1473825163123179522',
//     '27216_1481532458145759234'
//   )
//   // 添加im消息列表
//   this.setRecordMessageList(list)
//   // 打开im弹框
//   this.chatRecordVal = true
// }
